import { SUPPORT_ENABLED } from '../../fields'
import { isValidBoolean } from '../helpers/fields'

export const validateSupportEnabled = (value?: boolean | null) => {
    isValidBoolean(value, SUPPORT_ENABLED)
}
